import React from 'react'
import { css, SerializedStyles } from '@emotion/core'
import { Select as AntSelect } from 'antd'

// dropdownAlignはantd v3の型定義に含まれていないためany型でキャスト
const SelectWithDropdown = AntSelect as any

type Option = {
  value: string
  label: string
}

type Props = {
  value: string
  onChange: (value: string) => void
  options: Option[]
  placeholder?: string
  width?: number
  customStyle?: SerializedStyles
}

export const TextInputWithDropdown: React.FC<Props> = ({ value, onChange, options, placeholder, width = 302, customStyle }) => {
  return (
    <div css={[wrapperStyle, customStyle]}>
      {/* overflow:hiddenの外にSelectを配置してdropdownがclipされないようにする */}
      <div css={{ position: 'relative', border: '1px solid #CCCCCC', borderRadius: 16, overflow: 'hidden' }}>
        <input
          type="text"
          css={inputStyle}
          style={{ width }}
          value={value}
          onChange={e => onChange(e.target.value)}
          placeholder={placeholder}
        />
        <div css={arrowButtonStyle}>
          <img src={require('@/static/images/arrow_yellow.svg')} css={arrowIconStyle} />
        </div>
      </div>
      <SelectWithDropdown
        css={selectStyle}
        onChange={(v: string) => onChange(v)}
        value={undefined}
        suffixIcon={null}
        dropdownMatchSelectWidth={false}
        dropdownStyle={{ width }}
        dropdownAlign={{ points: ['tr', 'br'] }}
        getPopupContainer={() => document.body}
      >
        {options.map(opt => (
          <AntSelect.Option key={opt.value} value={opt.value}>
            {opt.label}
          </AntSelect.Option>
        ))}
      </SelectWithDropdown>
    </div>
  )
}

const wrapperStyle = css({
  position: 'relative',
})

const inputStyle = css({
  height: 32,
  padding: '8px 16px',
  border: 'none',
  textAlign: 'left',
  appearance: 'none',
  '::placeholder': {
    color: '#ccc',
  },
})

const arrowButtonStyle = css({
  position: 'absolute',
  width: 32,
  height: '100%',
  right: 0,
  top: 0,
  borderLeft: '1px solid #d0d0d0',
  background: '#eee',
  cursor: 'pointer',
})

const arrowIconStyle = css({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  pointerEvents: 'none',
})

const selectStyle = css({
  position: 'absolute',
  right: 0,
  top: 0,
  width: 32,
  height: '100%',
  opacity: 0,
  cursor: 'pointer',
  '.ant-select-selection': {
    border: 'none',
    height: '100%',
  },
})
